import axios from "axios"

export const fetchTherapists = async (data, token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/therapist/matchTherapist",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        withCredentials: true,
      },
    }
  )

export const previousBooking = async (data, token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/therapist/previousBooking",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

export const therapistSlots = async (data, token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/therapist/availableSlots",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

export const therapistDashboardInfo = async (token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI + "/api/therapist/therapistDashboardInfo",
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

export const getTherapistProfile = async(selectedClientFilter, token) => 
  await axios.get(
    `${process.env.REACT_APP_SERVER_URI}/api/therapist/profile?range=${selectedClientFilter}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )

export const updateProfile = async(bio, experienceInYears, image, languages) => 
  await axios.patch(
    `${process.env.REACT_APP_SERVER_URI}/api/therapist/profile`,
    {
      bio,
      experienceInYears,
      image,
      languages
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )

export const sendChatNotification = async (payload, token) =>
  await axios.post(
    process.env.REACT_APP_SERVER_URI + "/api/chat_notification",
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )